export const visit = (vm, at) => {
vm(require("./availability/da.lyaml"));
vm(require("./typical-response-time/da.lyaml"));
vm(require("./default/da.lyaml"));
at({ "da": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "okay" } } });
};